import client from '../client';

export default {
  // Seller 获取当前站点媒体白名单状态
  getWhitelistStatus: () =>
    client.get('seller/publisher-whitelist/settings').then(res => res.data),
  // Seller 更新当前站点媒体白名单开关
  updateWhitelistStatus: data =>
    client.patch('seller/publisher-whitelist/enabled', data).then(res => res.data),
  // Seller 分页查询当前站点媒体白名单
  getWhitelistList: data =>
    client.get('seller/publisher-whitelist', { params: data }).then(res => res.data),
  // Seller 分页查询可加入当前站点白名单的媒体
  getEligiblePublishers: data =>
    client.get('seller/publisher-whitelist/eligible-publishers', { params: data }).then(res => res.data),
  //Seller 添加当前站点媒体白名单
  addWhitelistPublisher: data =>
    client.post('seller/publisher-whitelist', data).then(res => res.data),
  //Seller 删除当前站点媒体白名单
  deleteWhitelistPublisher: data =>
    client.delete(`seller/publisher-whitelist/${data.publisherId}`).then(res => res.data),
  // Seller 复制当前站点白名单到其他站点
  copyWhitelistToMarketplaces: data =>
    client.post('seller/publisher-whitelist/sync', data).then(res => res.data),
};
